import { z } from 'zod'

/** My time (`/projects/time`): the week (any date in it), the day open in the day list, and the view. */
export const myTimeSearchSchema = z.object({
  week: z.iso.date().optional().catch(undefined),
  day: z.iso.date().optional().catch(undefined),
  /** Desktop only: the day list instead of the week grid (phones always show the day list). */
  view: z.enum(['day']).optional().catch(undefined),
})
export type MyTimeSearch = z.infer<typeof myTimeSearchSchema>

/** Time approvals (`/projects/time/approvals`). */
export const timeApprovalsSearchSchema = z.object({
  projectId: z.uuid().optional().catch(undefined),
})
export type TimeApprovalsSearch = z.infer<typeof timeApprovalsSearchSchema>
